import { ButtonBlock as ButtonBlockProps, Page } from '@/payload-types';

import Button from '@/components/button';
import { WithTheme } from '@/types/WithTheme';

const ButtonBlock = (props: ButtonBlockProps & WithTheme) => {
  const { link, buttonStyle, theme } = props;

  const url = link?.type === 'custom' ? link?.url : (link?.reference?.value as Page)?.slug;

  return (
    <Button
      {...props}
      openInNewTab={link?.newTab ?? false}
      style={buttonStyle ?? 'primary-button'}
      url={url ?? ''}
      theme={theme}
    >
      {link.label}
    </Button>
  );
};

export default ButtonBlock;
